// Customer key prefers email, falls back to phone, then to a stable name+id signature
// so guests with no email still get grouped reasonably.
const customerKey = (booking) => {
    const email = (booking.email || '').trim().toLowerCase();
    if (email) return `e:${email}`;
    const phone = (booking.phone || '').replace(/\s+/g, '');
    if (phone) return `p:${phone}`;
    const name = `${booking.firstName || ''} ${booking.lastName || ''}`.trim().toLowerCase();
    return name ? `n:${name}` : `b:${booking.id}`;
};

const bookingTime = (booking) => {
    const value = booking.timeslot?.startTime;
    if (!value) return 0;
    const t = new Date(value).getTime();
    return Number.isFinite(t) ? t : 0;
};

export const groupBookingsByCustomer = (bookings = []) => {
    const map = new Map();
    bookings.forEach((booking) => {
        const key = customerKey(booking);
        let entry = map.get(key);
        if (!entry) {
            entry = {
                key,
                firstName: booking.firstName || '',
                lastName: booking.lastName || '',
                email: booking.email || '',
                phone: booking.phone || '',
                bookings: [],
            };
            map.set(key, entry);
        }
        // Keep contact details up to date — prefer the latest non-empty value.
        if (!entry.email && booking.email) entry.email = booking.email;
        if (!entry.phone && booking.phone) entry.phone = booking.phone;
        if (!entry.firstName && booking.firstName) entry.firstName = booking.firstName;
        if (!entry.lastName && booking.lastName) entry.lastName = booking.lastName;
        entry.bookings.push(booking);
    });

    const customers = Array.from(map.values()).map((entry) => {
        const sorted = [...entry.bookings].sort((a, b) => bookingTime(b) - bookingTime(a));
        return {
            ...entry,
            bookings: sorted,
            lastBooking: sorted[0],
            bookingCount: sorted.length,
        };
    });

    customers.sort((a, b) => bookingTime(b.lastBooking) - bookingTime(a.lastBooking));
    return customers;
};

export const filterCustomers = (customers, search) => {
    const needle = (search || '').trim().toLowerCase();
    if (!needle) return customers;
    return customers.filter((c) => {
        const name = `${c.firstName} ${c.lastName}`.toLowerCase();
        return (
            name.includes(needle) ||
            (c.email || '').toLowerCase().includes(needle) ||
            (c.phone || '').toLowerCase().includes(needle)
        );
    });
};
